import {home} from "./pages/home";
import {categories} from "./pages/categories";
import {archive} from "./pages/archive";
import {directory} from "./pages/directory";
import {toolGallery} from "./pages/toolGallery";
import {profileMenu} from "./components/profileMenu";
import {footer} from "./components/footer";
import {news} from "./pages/news";
import {comments} from "./pages/comments";
import {analytics} from "./components/analytics";
import {relatedTools} from "./pages/relatedTools";
import {outboundLinks} from "./components/outboundLinks";
import {profiles} from "./pages/profiles";
import {subscribeQuiz} from "./pages/subscribe";
import {modelComparison} from "./pages/modelComparison";

analytics();
outboundLinks();
profiles();
subscribeQuiz();
home();
categories();
archive();
directory();
toolGallery();
profileMenu();
footer();
news();
comments();
relatedTools();
modelComparison();
